import Div from '@/shared/Div';
import Divider from '@/shared/Divider';
import Paragraph from '@/shared/Paragraph';
import React from 'react';
import Map from '../Map';
import classNames from 'classnames';
import LinkButton from '@/shared/LinkButton';
import Span from '@/shared/Span';

type ListItem = {
  Icon: any;
  title: string;
};

type StepsList = {
  title: string;
};

type LinkType = {
  label: string;
  href: string;
  target?: string;
};

type ProductExchangeProps = {
  data: {
    heading: string;
    description?: string;
    list: ListItem[];
    stepsList: StepsList[];
    link: LinkType | null;
  };
  hideImages?: boolean;
  categoryType?: string;
};

function ExchangeLearnMore({ data, hideImages, categoryType }: ProductExchangeProps) {
  const { heading, description, stepsList, list, link } = data;

  return (
    <Div className="mx-s5 flex flex-col gap-s6">
      <Div>
        <Paragraph className="text-h-3 mb-s5">{heading}</Paragraph>
        {description ? (
          <Paragraph className="text-body-lg mt:s3">
            {description.replace('{old product}', categoryType || 'old product')}{' '}
            {link ? (
              <LinkButton className="text-cu-selected" href={link.href} target={link.target}>
                <Span>{link.label}</Span>
              </LinkButton>
            ) : null}
          </Paragraph>
        ) : null}
      </Div>
      {hideImages ? null : (
        <>
          <Divider />
          <Map
            className="flex gap-s4"
            list={list}
            wrapper="div"
            render={({ Icon, title }, index) => {
              return (
                <Div
                  className="flex flex-1 flex-col gap-s2 items-center flex-grow text-center"
                  key={index}
                >
                  {Icon}
                  <Paragraph>{title}</Paragraph>
                </Div>
              );
            }}
          />

          <Divider />
        </>
      )}
      <Map
        className="flex flex-col gap-s6"
        list={stepsList}
        wrapper="div"
        render={(item, index) => {
          const { title, subTitle } = item;
          return (
            <Div className="flex gap-s6" key={index}>
              <Div>
                {' '}
                <Div className="w-8 h-8 border border-co-bold rounded-3xl	flex justify-center items-center text-h-4">
                  {index + 1}
                </Div>
              </Div>
              <Div className="flex flex-col gap-s2">
                <Paragraph className={classNames('', { 'text-h-4': subTitle })}>{title}</Paragraph>
                {subTitle ? <Paragraph>{subTitle}</Paragraph> : null}
              </Div>
            </Div>
          );
        }}
      />
      {hideImages ? (
        <Div className="px-s5 py-s4 rounded-cs bg-[#E5F1FF]">
          <Paragraph className="text-cm-primary text-body-lg">
            If there is a product mis-match, your order will be cancelled.
          </Paragraph>
        </Div>
      ) : null}
    </Div>
  );
}

export default React.memo(ExchangeLearnMore);
